var map = {
	"./add.svg": 4935,
	"./bicycle.svg": 6449,
	"./cars.svg": 4853,
	"./charging.svg": 1822,
	"./check-mark.svg": 4412,
	"./check.svg": 2335,
	"./close-white.svg": 6185,
	"./close.svg": 318,
	"./cooperation.svg": 4426,
	"./edit-pencil.svg": 6015,
	"./info.svg": 4780,
	"./location.svg": 4001,
	"./nature.svg": 2146,
	"./ok-black.svg": 2681,
	"./ok-white.svg": 2897,
	"./ok.svg": 3457,
	"./pump.svg": 7488,
	"./reach.svg": 8245,
	"./save.svg": 6751,
	"./share.svg": 3517,
	"./skoda.svg": 3250,
	"./skyline.svg": 1122,
	"./sustainability.svg": 7719,
	"./vision7s.svg": 7789,
	"./x.svg": 6169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9589;